// ** React Imports
import { useEffect, useState } from 'react'
import { Badge } from 'reactstrap'
import { useSelector } from 'react-redux'
import { useNotificationService } from '../../../../_services/NotificationService'
import styled from 'styled-components'
import { Notifications } from '../../../containers/Notifications'
import { Drawer } from 'dsm-react-lib'
import { modifyTopbarStyle } from '../../../../utility/Utils'
import { IconBell } from '@tabler/icons-react'

export const Message = styled.div`
  white-space: nowrap;
  width: 340px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: smaller;
  color: var(--text-subheading);
`

export const StyledBell = styled(IconBell)`
  color: var(--text-heading);
  &:hover {
    cursor: pointer;
  }
`

const NotificationDropdown = () => {
  const [openSidebar, setOpenSidebar] = useState(false)
  const [appIcons, setAppIcons] = useState()
  const layoutStore = useSelector((state) => state.layoutReducer)
  const menuCollapsed = layoutStore.menuCollapsed

  const allNotifications = useSelector(
    (state) => state.notificationContextReducer.notificationContext
  )
  const context = allNotifications.notifications.filter(
    (sidebar) => sidebar.notificationType === 'SideScreen'
  )
  const { getIcons, refreshNotifications, refreshNewCount, markAllNotificationsAsSeen } =
    useNotificationService()

  useEffect(() => {
    const fetchAppIcons = async () => {
      modifyTopbarStyle(openSidebar, menuCollapsed)
      if (openSidebar) {
        const res = await refreshNotifications(30)
        if (allNotifications?.newCount > 0) markAllNotificationsAsSeen()
        const fetchAppIcons = async () => {
          const appIds = res.map(({ applicationId }) => applicationId)
          const response = await getIcons([...new Set(appIds)])
          setAppIcons(response)
        }
        if (res && res.length > 0) {
          fetchAppIcons()
        } else {
          setAppIcons([])
        }
      } else {
        refreshNewCount()
      }
    }
    fetchAppIcons()
  }, [openSidebar])

  return (
    <>
      <div
        id="bell"
        className="workspace-notification-intro position-relative"
        data-tooltip-id="bell">
        {allNotifications.newCount > 0 && (
          <Badge pill color="danger" className="badge-up">
            {allNotifications.newCount > 99 ? '99+' : allNotifications.newCount}
          </Badge>
        )}
        <StyledBell
          size={22}
          onClick={() => setOpenSidebar(!openSidebar)}
          data-testid="notificationBellBtn"
        />
      </div>
      <Drawer
        className="w-[35vw] theme-drawer notification-centre-drawer"
        header={
          <div className="flex items-center w-full pr-2">
            <h4 className="subsection-header mb-0 p-1">Notification centre</h4>
          </div>
        }
        hasCloseButton={true}
        isOpen={openSidebar}
        setIsOpen={() => setOpenSidebar(false)}
        closeOnOutsideClick={true}
        overlay={true}>
        {openSidebar && (
          <Notifications toggle={() => setOpenSidebar(!openSidebar)} appIcons={appIcons} />
        )}
      </Drawer>
    </>
  )
}

export default NotificationDropdown
